import { Label, InputText, Switch } from '@teo/components';
import { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { useGet } from '@/query/fetchHooks';
import { parseFilter } from '@/util';

import { Tag } from '@teo/components/icons';

import { PaginationMultiselectWithTags } from '@/components/PaginationMultiselectWithTags';
import i18n from 'i18next';
import { axios } from '@/axios';
import { config } from '@/config';
import { PaginationMultiSelect } from '@/components/PaginationMultiSelect';
import EstimatedTimeInput from '@/components/TimeComponent/TimeComponent';

export const SettingsExtraInfo = ({
  les,
  setLesTitle,
  lesTitle,
  setLessonVerified,
  lessonVerified,
  setEstimatedTime,
  estimatedTime,
  setSelectTags,
  selectTags,
  setSelectCategories,
  selectCategories,
  setLesTags,
  lesCategories,
  setLesCategories,
  lesTags,
}) => {
  const { auth } = useContext(AuthContext);
  const { t } = useTranslation();
  const [filterTag, setFilterTag] = useState('');
  const [tags, setTags] = useState([]);

  const [filter, setFilter] = useState('');

  const allTags = useGet(`/tags`, {
    enabled: !!les?.lessonId,
    count: 10,
    sort: 'tag',
    lang: auth?.user?.lang,
    q: parseFilter(filterTag),
  });

  useGet(`/lessontags`, {
    enabled: !!les?.lessonId,
    lessonId: les?.lessonId,
    search: 'tag:%',
    onSuccess: (result) => {
      setLesTags(result.data || {});
    },
  });

  useGet(`/lessontags`, {
    enabled: !!les?.lessonId,
    lessonId: les?.lessonId,
    search: 'category:%',
    onSuccess: (result) => {
      setLesCategories(result.data || {});
    },
  });

  useGet(`/directorytags`, {
    enabled: !les?.assetId && !les?.lessonId,
    directoryId: les?.id,
    search: 'tag:%',
    onSuccess: (result) => {
      setLesTags(result.data || {});
    },
  });

  useGet(`/directorytags`, {
    enabled: !les?.assetId && !les?.lessonId,
    directoryId: les?.id,
    search: 'category:%',
    onSuccess: (result) => {
      setLesCategories(result.data || {});
    },
  });

  useEffect(() => {
    if (allTags?.data) {
      const data = allTags?.data?.data?.map((tag) => ({
        id: tag?.id,
        key: tag?.tag,
        label: tag?.tag,
        tag: tag?.tag,
      }));
      setTags(data);
    }
  }, [allTags?.data]);

  useEffect(() => {
    if (lesTags) {
      lesTags?.map((tag) => {
        const val = selectTags?.find((el) => el.id === tag?.id);
        if (!val) {
          setSelectTags((prev) => [
            ...prev,
            {
              id: tag?.id,
              key: tag?.tag.split('tag:')[1],
              label: tag?.tag.split('tag:')[1],
              tag: tag?.tag.split('tag:')[1],
            },
          ]);
        }
      });
    }
  }, [lesTags]);

  useEffect(() => {
    if (lesCategories) {
      lesCategories?.map((tag) => {
        const val = selectCategories?.find((el) => el.id === tag?.id);
        if (!val) {
          setSelectCategories((prev) => [
            ...prev,
            {
              id: tag?.id,
              key: tag?.tag.split('category:')[1],
              label: tag?.tag.split('category:')[1],
              tag: tag?.tag.split('category:')[1],
            },
          ]);
        }
      });
    }
  }, [lesCategories]);

  const handleAddTag = () => {
    if (filter) {
      axios.post(`${config.backend}/tags`, {
        tag: filter,
        label: filter,
        key: Math.floor(Math.random() * 9999999999999),
        organisationId: auth?.user?.activeOrganisationId,
        lang: auth?.user?.lang,
      });
      setSelectTags((prev) => [
        ...prev,
        {
          key: filter,
          label: filter,
          tag: filter,
        },
      ]);
      setFilter('');
    }
  };

  return (
    <div className="">
      <h1 className="text-base font-semibold">
        {t('pages.create_edit_course.extra_info_settings_title')}
      </h1>
      <p className="mt-2 text-sm font-normal text-[#7d7d81]">
        {t('pages.create_edit_course.extra_info_settings_subtitle')}
      </p>
      <div className="flex h-full w-full md:w-full md:items-center">
        <div className="mb-1 w-full space-y-4 md:space-y-6">
          <div>
            <Label htmlFor="lesTitle">
              <p className="mt-6 text-sm font-semibold">
                {t('pages.create_edit_course.title_extra_info')}
              </p>
            </Label>
            <InputText
              disabled={!les.canEdit && (les?.lessonId || les?.assetId)}
              title={
                !les.canEdit && (les?.lessonId || les?.assetId)
                  ? t('pages.create_edit_course.title_lesson_disabled')
                  : undefined
              }
              id="lesTitle"
              type="text"
              onChange={(e) => setLesTitle(e.target.value)}
              value={lesTitle}
            />
          </div>

          {les?.lessonId && ( //lesson
            <>
              <div className="relative z-[12]">
                <Label htmlFor="categories">
                  <p className="mt-6 text-sm font-semibold">
                    {t('pages.create_edit_course.tags')}
                  </p>
                </Label>
                <div className="relative z-[12] flex items-center">
                  <Tag className="mr-2 h-[17.5px] w-[17.5px] text-[#6d6d72]" />

                  <div className="w-full">
                    <PaginationMultiselectWithTags
                      value={selectTags}
                      onChange={(value) => {
                        setSelectTags(value);
                      }}
                      filter={filter}
                      setFilter={setFilter}
                      keyFn={(row) => row?.tag}
                      fetch={useGet.bind(
                        null,
                        `/tags?lang=${i18n.language}&organisationId=${auth?.user?.activeOrganisationId},OR,organisationId=null`
                      )}
                      defaultSort={[{ id: 'tag', desc: false }]}
                      render={(row) => {
                        return row?.tag;
                      }}
                      customStyles="bg-white"
                      addTagLabel={`${filter} ${t(
                        'pages.create_edit_course.addTagLabel'
                      )}`}
                      handleAddTag={handleAddTag}
                      placeholder={
                        selectTags?.length > 0
                          ? ''
                          : t('pages.create_edit_course.tags_placeholder')
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="relative z-[11]">
                <Label htmlFor="categories">
                  <p className="mt-6 text-sm font-semibold">
                    {t('pages.create_edit_course.categories')}
                  </p>
                </Label>

                <PaginationMultiSelect
                  value={selectCategories}
                  onChange={(value) => {
                    setSelectCategories(value);
                  }}
                  keyFn={(row) => row?.tag}
                  fetch={useGet.bind(
                    null,
                    `/categories?lang=${i18n.language}&organisationId=${auth?.user?.activeOrganisationId},OR,organisationId=null`
                  )}
                  defaultSort={[{ id: 'tag', desc: false }]}
                  render={(row) => {
                    return row?.tag;
                  }}
                />
              </div>

              <div className="mt-4 flex flex-row items-center gap-4 rounded-lg border border-grey-02 p-4">
                <div>
                  <Switch
                    checked={lessonVerified}
                    onChange={(isCheck) => setLessonVerified(isCheck)}
                  />
                </div>
                <div>
                  <h4 className="pb-2 font-normal">
                    {t('pages.create_edit_course.verified_content')}
                  </h4>
                  <p className="text-xs text-grey-05">
                    {t('pages.create_edit_course.verified_content_description')}
                  </p>
                </div>
              </div>

              <div
                className="mt-5 flex flex-col"
                data-testid="reminderMemories"
              >
                <EstimatedTimeInput
                  value={estimatedTime}
                  onChange={(value) => setEstimatedTime(value)}
                  label={t('pages.create_edit_course.estimated_time')}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
